import * as React from 'react';
import { Form, Text, FormValues, FormErrors } from 'react-form';
import { BaseFormProps, BaseFormState } from '../../../interfaces';
import { ValidationService, TenantDataService } from '../../../services';
import { Tenant } from '../../../models';
import { observer, inject } from 'mobx-react';
import { ServiceStore } from '../../../stores';

interface FormProps extends BaseFormProps {
    ServiceStore?: ServiceStore;
}

interface FormState extends BaseFormState {
    tenants: Tenant[];
}

@inject('ServiceStore') @observer
export class ScoreCardGroupForm extends React.Component<FormProps, FormState> {
    private vs = new ValidationService();
    private tenantDataService: TenantDataService;

    constructor(props: BaseFormProps) {
        super(props);

        this.state = {
            canSubmit: true,
            formErrors: {},
            tenants: []
        };

        this.props.defaultValues.surveyReportTypes = this.props.defaultValues.surveyReportTypes || [];

        this.tenantDataService = new TenantDataService(this.props.ServiceStore!.notificationService);

        this.validateErrors = this.validateErrors.bind(this);
        this.validateSuccess = this.validateSuccess.bind(this);
    }

    componentDidMount() {
        this.tenantDataService.getAll().then((tenants: Tenant[]) => {
            this.setState({ tenants: tenants });
        });
    }

    // Validation methods
    validateErrors(values: FormValues) {
        const { name } = values;
        let formErrors: any = {};

        if (name || name === '') {
            if (!this.vs.required(name)) {
                formErrors.name = 'Name is required.';
            } else if (!this.vs.cannotBeEmpty(name!)) {
                formErrors.name = 'Name cannot be blank.';
            }
        }

        return formErrors;
    }

    validateSuccess(values: FormValues, errors: FormErrors) {
        return errors;
    }
    // end of validation stuff

    public render() {
        const { canSubmit, formErrors } = this.state;
        
        return (
            <Form
                defaultValues={this.props.defaultValues}
                onSubmit={submittedValues => this.props.submit(submittedValues)}
                validateError={this.validateErrors}
                validateSuccess={this.validateSuccess}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        <div className="form-group">
                            <label htmlFor="name">Name *</label>
                            <Text className="form-control" field="name" id="name" />
                            {formErrors.name && <span className="help-block error-text">{formErrors.name}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Sort</label>
                            <Text className="form-control" field="sort" id="sort" />
                            {formErrors.name && <span className="help-block error-text">{formErrors.name}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Low</label>
                            <Text className="form-control" field="low" id="low" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Medium</label>
                            <Text className="form-control" field="medium" id="medium" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">High</label>
                            <Text className="form-control" field="high" id="high" />
                        </div>

                        <button type="submit" className="btn btn-primary" disabled={!canSubmit}>Save</button>
                    </form>
                )}
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroup/ScoreCardGroupForm.tsx